// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1788453777186
      var cssReload = require("D:/gitee/宠物升级/mer_mer_admin/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  